export default async (context, inject) => {
  inject('wovn', {
    get getLang() {
      return context.store.getters['wovn/getLang']
    },
    set setLang(value) {
      console.log(context.store)
      context.store.commit('wovn/changeLang', value)
    }
  })
}
